// extracted by mini-css-extract-plugin
export default {"label":"styles_label__tWby0","label-text":"styles_label-text__iuH97","optional":"styles_optional__OAc-7"};